<template>
  <div
    :class="[
      { 'mt-2': !boxClass },
      boxClass,
    ]"
  >
    <b-row md="12">
      <b-col md="5">
          <span  :class="headerClass" class="font-weight-bold">{{ label }}: </span>
      </b-col>
      <b-col md="7">  
      <template v-for="(value, variableId) in jobQuestion.value">
        <div :key="variableId" :class="valueClass">
          <component
            v-if="componentName"
            :is="componentName"
            :job-question="jobQuestion"
            :value="value"
            :variable="
              getVariable(
                isProfileJobTerms && typeof value == 'string' ? value : variableId
              )
            "
            :is-one-variable="jobQuestion.jobQuestionVariables.length === 1"
          />
        </div>
      </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { JOB_QUESTION_TYPES } from '@/store';
import RecruiterIcoCriteriaResultTypeSlider from '@/components/recruiter/ico/criteria/result/type/RecruiterIcoCriteriaResultTypeSlider';
import RecruiterIcoCriteriaResultTypeDefault from '@/components/recruiter/ico/criteria/result/type/RecruiterIcoCriteriaResultTypeDefault';
import RecruiterIcoCriteriaResultTypeSelectAny from '@/components/recruiter/ico/criteria/result/type/RecruiterIcoCriteriaResultTypeSelectAny';
import RecruiterIcoCriteriaResultTypeYesNo from '@/components/recruiter/ico/criteria/result/type/RecruiterIcoCriteriaResultTypeYesNo';
import RecruiterIcoCriteriaResultTypeMultiVariableSelectOne from '@/components/recruiter/ico/criteria/result/type/RecruiterIcoCriteriaResultTypeMultiVariableSelectOne';
import RecruiterIcoCriteriaResultTypeSelectOne from '@/components/recruiter/ico/criteria/result/type/RecruiterIcoCriteriaResultTypeSelectOne';
import RecruiterIcoCriteriaResultTypeRating from '@/components/recruiter/ico/criteria/result/type/RecruiterIcoCriteriaResultTypeRating';

export default {
  name: 'RecruiterIcoCriteriaResultJobQuestion',
  components: {
    RecruiterIcoCriteriaResultTypeSlider,
    RecruiterIcoCriteriaResultTypeDefault,
    RecruiterIcoCriteriaResultTypeSelectAny,
    RecruiterIcoCriteriaResultTypeYesNo,
    RecruiterIcoCriteriaResultTypeMultiVariableSelectOne,
    RecruiterIcoCriteriaResultTypeSelectOne,
    RecruiterIcoCriteriaResultTypeRating,
  },
  props: {
    jobQuestion: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      required: true,
    },
    boxClass: {
      validator: (prop) => typeof prop === 'string' || prop === null,
      default: null,
    },
    headerClass: {
      validator: (prop) => typeof prop === 'string' || prop === null,
      default: null,
    },
    valueClass: {
      validator: (prop) => typeof prop === 'string' || prop === null,
      default: null,
    },
  },
  computed: {
    hasJobQuestionAnswer: function () {
      return (
        this.jobQuestion.value &&
        ((Array.isArray(this.jobQuestion.value) &&
          this.jobQuestion.value.length) ||
          Object.keys(this.jobQuestion.value).length)
      );
    },
    isProfileJobTerms: function () {
      return [
        JOB_QUESTION_TYPES.VISA_STATUS,
        JOB_QUESTION_TYPES.ETHNICITY,
        JOB_QUESTION_TYPES.GENDER,
      ].some((t) => this.jobQuestion.talent_type === t);
    },
    componentName: function () {
      if (!this.hasJobQuestionAnswer) return false;
      switch (this.jobQuestion.talent_type) {
        case JOB_QUESTION_TYPES.SLIDER:
          return RecruiterIcoCriteriaResultTypeSlider.name;
        case JOB_QUESTION_TYPES.SELECT_ANY:
          return RecruiterIcoCriteriaResultTypeSelectAny.name;
        case JOB_QUESTION_TYPES.YES_NO:
        case JOB_QUESTION_TYPES.BOARD_CERTIFICATION:
          return RecruiterIcoCriteriaResultTypeYesNo.name;
        case JOB_QUESTION_TYPES.VISA_STATUS:
        case JOB_QUESTION_TYPES.ETHNICITY:
        case JOB_QUESTION_TYPES.GENDER:
          return RecruiterIcoCriteriaResultTypeSelectOne.name;
        case JOB_QUESTION_TYPES.MULTI_VARIABLE_SELECT_ONE:
          return RecruiterIcoCriteriaResultTypeMultiVariableSelectOne.name;
        case JOB_QUESTION_TYPES.SELECT_ONE:
          return RecruiterIcoCriteriaResultTypeSelectOne.name;
        case JOB_QUESTION_TYPES.RATING:
          return RecruiterIcoCriteriaResultTypeRating.name;
        default:
          return RecruiterIcoCriteriaResultTypeDefault.name;
      }
    },
    label: function () {
      return this.jobQuestion.talent_label || this.jobQuestion.label;
    },
  },
  methods: {
    getVariable: function (id) {
      if (this.isProfileJobTerms) {
        return this.jobQuestion.jobQuestionVariables.find((v) => v.id === id);
      }
      return this.jobQuestion.jobQuestionVariables.find(
        (v) => parseInt(v.id) === parseInt(id)
      );
    },
  },
};
</script>

<style scoped />
